import _SessionGateQuery from "../__generated__/SessionGateQuery.graphql";
import { graphql, useLazyLoadQuery } from 'react-relay';
import { Navigate } from 'react-router-dom';
import { SessionStart } from './SessionStart';
import type { SessionGateQuery } from '../__generated__/SessionGateQuery.graphql';
const GateQuery = (_SessionGateQuery.hash && _SessionGateQuery.hash !== "5de3060d284a94520d497f062bd9ee0c" && console.error("The definition of 'SessionGateQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _SessionGateQuery);

/**
 * What `/session` means: resume if there is something to resume, otherwise
 * offer to start.
 *
 * A component rather than a route loader — `routes.tsx` keeps Relay as the only
 * fetcher, and a loader here would be a second cache racing the first.
 *
 * `network-only`, and this is the part that matters. `endSession` selects only
 * `id` and `status` on the session it ended, so nothing in the store
 * invalidates `lastSession`; served from cache, this screen would read the
 * session the learner just finished, still marked `ACTIVE`, and send them
 * straight back into it. `refreshAudioToken` would then refuse the token and
 * they would land on a dead conversation they had deliberately left.
 *
 * `lastSession` falls back to the most recent *ended* session when there is no
 * active one — see its resolver. Only `ACTIVE` resumes here; the rest of what
 * that field offers belongs to the history screen, not to this decision.
 *
 * Relative `to`: an index route resolves relative paths against its parent, so
 * this is `/session/<id>`. `replace`, so Back does not bounce between the gate
 * and the conversation it chose.
 */
export function SessionGate() {
  const data = useLazyLoadQuery<SessionGateQuery>(GateQuery, {}, {
    fetchPolicy: 'network-only'
  });
  const last = data.me?.learner?.lastSession;
  if (last?.status === 'ACTIVE') return <Navigate to={last.id} replace />;
  return <SessionStart />;
}